__turbopack_context__.v({
  "main": "landing-module__rxtELG__main",
  "page": "landing-module__rxtELG__page",
});
